module.exports = __webpack_public_path__ + "img/logo_navbar.1a336173.png";